import axios from 'axios';
import { serverConfig } from './server-config';
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            // Auth token has expired or is invalid, delete it from local storage
            localStorage.removeItem('authToken');
            location.reload();
        }
        return Promise.reject(error);
    }
);
export const PsychometricService = {
    discRegister: async () => {
        return axios.post(
            `https://${serverConfig.serverBaseAddress}/signite/disc/register`,
            null,
            {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('authToken'),
                },
            }
        );
    },
    getResults: async (transactionId) => {
        return axios.get(
            `https://${serverConfig.serverBaseAddress}/signite/assessment/result/${transactionId}`,

            {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('authToken'),
                },
            }
        );
    },
};
